import React, { useState } from 'react';
import { Select } from '@amzn/stencil-react-components/select';
import { Col, Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { buildSegmentListOption, segmentListFilter } from '../../util/campaign/campaignUtils';
import { updateCampaignForm, updateTestEmailDetails } from '../../actions/createScheduleAction';
import { CampaignFormSection } from '../../enums/schedulingConstant';
import { getAllSegments } from '../../actions/nudgeActions';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { accessById } from '../../util/journey/journeyUtils';

export const SegmentSection = ({ testView = false }) => {
  const dispatch = useDispatch();
  const segmentList = useSelector(store => store.nudge.segmentList);
  const isSubmitSuccess = useSelector(store => store.campaign.campaignFormState.isSubmitSuccess);
  const userInfo = useSelector(store => store.userInfo);
  const campaignFormState = useSelector(store => store.campaign.campaignFormState);
  const buildSegmentList = buildSegmentListOption(segmentList);
  const [isLoading, setIsLoading] = useState(false);
  const segmentValueAccessor = accessById;

  const segmentsRenderOption = option => (
    <Row display="flex" flexDirection="column" gridGap="S200">
      <Row alignItems="center">{option?.name}</Row>
      {option?.description && (
        <Row display={'flex'} gridGap="S200" fontSize="T100" color="neutral70">
          <Text fontSize="T100">Description: </Text>
          <Text fontSize="T100">{option.description}</Text>
        </Row>
      )}
      <Text fontSize="T100" color="neutral70">
        {option?.createdBy && (
          <Row display={'flex'} gridGap="S200" flexDirection="row">
            <Text fontSize="T100">Created by: </Text>
            <Text fontSize="T100" style={{ fontWeight: 'bold' }}>
              {option?.createdBy}
            </Text>
          </Row>
        )}
      </Text>
    </Row>
  );

  const segmentFilterOption = searchText => segmentListFilter(searchText, buildSegmentList);

  const [selectedSegment, setSelectedSegment] = useState({
    name: campaignFormState?.segmentDetails?.segmentName ?? '',
    id: campaignFormState?.segmentDetails?.segmentId ?? '',
  });
  const onSelectSegment = e => {
    setSelectedSegment(e);
    if (testView) {
      dispatch(
        updateTestEmailDetails(CampaignFormSection.SEGMENT, {
          segmentName: e?.name,
          segmentId: e?.id,
        }),
      );
    } else {
      dispatch(
        updateCampaignForm(CampaignFormSection.SEGMENT, {
          segmentName: e?.name,
          segmentId: e?.id,
        }),
      );
    }
  };

  const refreshSegmentList = async () => {
    setIsLoading(true);
    await dispatch(getAllSegments(userInfo.selectedAccessGroupName, userInfo.idToken));
    setIsLoading(false);
  };

  return (
    <Col gridGap="S200">
      <Label htmlFor="choose-segment" id="choose-segment-label">
        <FormattedMessage
          id="app.campaign.label.chooseASegment"
          defaultMessage="Choose a segment"
        />
      </Label>
      <Select
        error={false}
        id="choose-segment"
        data-testid="select-segment-dp"
        isMulti={false}
        isSearchable={true}
        labelId="choose-segment-label"
        disabled={isSubmitSuccess}
        onChange={e => {
          onSelectSegment(e);
        }}
        options={buildSegmentList}
        value={selectedSegment}
        valueAccessor={segmentValueAccessor}
        optionToString={option => option.name}
        renderOption={segmentsRenderOption}
        filterOptions={segmentFilterOption}
        noOptionsText="No options found."
        placeholder="Select a segment for campaign"
      />
      <View
        display={'flex'}
        style={{ color: '#23756b', cursor: 'pointer' }}
        alignItems={'center'}
        onClick={refreshSegmentList}
        className={isLoading ? 'disabled' : ''}
      >
        Refresh
        <Spacer width={10} />
        {isLoading && <Spinner size={SpinnerSize.Small} />}
      </View>
    </Col>
  );
};
